import { useEffect, useRef, useState } from "react";
import { isNumber } from "es-toolkit/compat";
function useHover(props) {
    const [element, setElement] = useState(null);
    const timeout = useRef();
    const delay = props?.delay;
    const hoverDelay = delay && (isNumber(delay) ? delay : delay.hover);
    const unhoverDelay = delay && (isNumber(delay) ? delay : delay.unhover);
    const [hovered, setIsHovered] = useState(false);
    useEffect(()=>{
        if (null == element) return;
        const setDelayedHover = (isHovered, delay)=>{
            if (timeout.current) clearTimeout(timeout.current);
            if (delay) timeout.current = setTimeout(()=>setIsHovered(isHovered), delay);
            else setIsHovered(isHovered);
        };
        const handlePointerEnter = ()=>setDelayedHover(true, hoverDelay);
        const handlePointerLeave = (event)=>{
            if (element.contains(event.target)) setDelayedHover(false, unhoverDelay);
        };
        if (timeout.current) clearTimeout(timeout.current);
        element.addEventListener('pointerenter', handlePointerEnter);
        element.addEventListener('pointerleave', handlePointerLeave);
        return ()=>{
            element.removeEventListener('pointerenter', handlePointerEnter);
            element.removeEventListener('pointerleave', handlePointerLeave);
        };
    }, [
        hoverDelay,
        unhoverDelay,
        element
    ]);
    return [
        setElement,
        hovered
    ];
}
export { useHover };
